import { css } from 'styled-components';
export const OnFocusInput = (opts) => css `
  border: 2px solid ${({ theme }) => theme.colors.AccentPurple};
  border-radius: 8px;
  ${opts?.openBorderLocation === 'top'
    ? css `
        border-top: none;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      `
    : css `
        border-top: 2px solid ${({ theme }) => theme.colors.AccentPurple};
      `}
  ${opts?.openBorderLocation === 'bottom'
    ? css `
        border-bottom: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      `
    : css `
        border-bottom: 2px solid ${({ theme }) => theme.colors.AccentPurple};
      `}
`;
export const InputWrapperCSS = css `
  width: 100%;
`;
export const InputBaseCSS = css `
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  background-color: #ffffff;
  background: #ffffff;
  background-image: none !important;
  border: 1px solid ${({ theme }) => theme.colors.Grey6};
  border-radius: 8px;
  min-height: 38px;
  height: 38px;
  color: #45424e;
  outline: none;
  box-shadow: 0 0 0 0 transparent;
  transition: box-shadow 100ms linear, border-color 100ms linear;

  width: 100%;
  &::placeholder {
    color: ${({ theme }) => theme.colors.TextDisabled};
  }

  &:focus {
    border-color: #342a6a;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:first-line,
  &focus:-webkit-autofill {
    ${({ theme }) => theme.fonts.PoppinsTextMedium};
    border-color: #e5dfa1 !important;
    box-shadow: 0 0 0 100px #fffff1 inset !important;
  }
  &:disabled {
    background-color: ${({ theme }) => theme.colors.Grey3};
    border: none;
  }
  &:enabled {
    &:active {
      background-color: white;
    }
  }
  ${({ theme, error }) => error &&
    css `
      border: 1px solid ${theme.colors.ErrorDefault};
    `}
`;
export const InputLabelCSS = css `
  font-size: 14px;
  line-height: 21px;
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-bottom: 4px;
  ${({ theme, disabled }) => disabled &&
    css `
      color: ${theme.colors.TextDisabled};
    `}
`;
export const InputRequiredAsteriskCSS = css `
  color: ${({ theme }) => theme.colors.ErrorDefault};
  margin-bottom: 0;
`;
export const InputErrorMessageCSS = css `
  ${({ theme }) => theme.fonts.PoppinsText};
  margin-top: 4px;
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.ErrorDefault};
`;
export const InputMessageCSS = css `
  ${({ theme }) => theme.fonts.PoppinsText};
  display: flex;
  margin-top: 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;
//# sourceMappingURL=index.js.map